/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable unicorn/consistent-function-scoping */
import { userKeeper } from '@mail-core/dashboard';
import classNames from 'clsx';
import hotkeys from 'hotkeys-js';
import { ReactComponent as LeftArrowIcon } from 'img/icons/leftArrow.svg';
import { ReactComponent as RightArrowIcon } from 'img/icons/rightArrow.svg';
import sha1 from 'js-sha1';
import xray from 'lib/xray';
import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';
import { ReactComponent as EditIcon } from 'mrg-icons/src/mailru/actions/compose.svg';
import React, { createRef, PureComponent, ReactElement, RefObject } from 'react';
import { downloadItem, openEditor } from 'reactApp/appHelpers/appHelpers';
import { BACK_URL, IS_B2B_BIZ_USER, IS_PUBLIC_ALBUM } from 'reactApp/appHelpers/configHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { ADS_TIMER_MS, emptyImageUrl } from 'reactApp/constants';
import { MAIL_ATTACHES_FOLDER_ID, REACT_VIEWER_ID } from 'reactApp/constants/magicIdentificators';
import { MAIL_HOST } from 'reactApp/modules/attaches/attaches.constants';
import { EAttachTypes } from 'reactApp/modules/attaches/attaches.types';
import { StackLimitedCache } from 'reactApp/modules/cache/StackLimitedCache';
import {
    getWeblinkFromPublicId,
    isAudio,
    isDocument,
    isImage,
    isPdf,
    isPlainSource,
    isVideo,
    isVirusItem,
} from 'reactApp/modules/file/utils';
import { getGoToAndScrollUrl } from 'reactApp/modules/modifying/modifying.helpers';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { EditorHeader } from 'reactApp/ui/EditorHeader/EditorHeader';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { BottomBanner } from 'reactApp/ui/ReactViewer/BottomBanner';
import { BottomToolbar } from 'reactApp/ui/ReactViewer/BottomToolbar/BottomToolbar';
import { FaceFilter } from 'reactApp/ui/ReactViewer/FaceFilter/FaceFilter';
import { PaginatorLine } from 'reactApp/ui/ReactViewer/PaginatorLine/PaginatorLine';
import { hotKeysScope, MAX_ZOOM_STATE, TIMEOUT_TO_INACTIVE } from 'reactApp/ui/ReactViewer/ReactViewer.constants';
import {
    calculateZoomValues,
    getDefaultZoomIdx,
    getItemImageUrl,
    getPosterUrl,
    IViewerDwhData,
    processItemPublish,
    sendViewerDwh,
    tryGetNearestIndexOfValue,
} from 'reactApp/ui/ReactViewer/ReactViewer.helpers';
import { IProps, IState } from 'reactApp/ui/ReactViewer/ReactViewer.types';
import { ViewerArchiveConnected } from 'reactApp/ui/ReactViewer/ViewerArchive/ViewerArchive';
import { ViewerButton } from 'reactApp/ui/ReactViewer/ViewerButton/ViewerButton';
import { ViewerImage } from 'reactApp/ui/ReactViewer/ViewerImage/ViewerImage';
import { renderCopyDialog, renderMoveDialog } from 'reactApp/ui/SelectFolderDialog/SelectFolderDialog.toolkit';
import { Spinner } from 'reactApp/ui/Spinner/Spinner';
import { SwipingComponent } from 'reactApp/ui/SwipingComponent/SwipingComponent';
import { sendXray as sendXrayFunc } from 'reactApp/utils/ga';
import { noop, roundCustom } from 'reactApp/utils/helpers';
import opener from 'reactApp/utils/opener';
import { ECategoryGa } from 'reactApp/utils/paymentGa';
import { scrollLock, scrollUnlock } from 'reactApp/utils/scrollLock';
import { getFileExtLimit } from 'reactApp/utils/textHelpers';
import { sendTmrGoal } from 'reactApp/utils/tmr';

import { AttachesBanner } from './AttachesBanner';
import styles from './ReactViewer.css';
import { Stub } from './Stub/Stub';
import { VideoPlayer } from './VideoPlayer/VideoPlayer';
import { ViewerDoc } from './ViewerDoc/ViewerDoc';
import { ViewerHeader } from './ViewerHeader/ViewerHeader';
import { ViewerPdf } from './ViewerPdf/ViewerPdf';
import { ViewerTxt } from './ViewerTxt/ViewerTxt';

const componentsCache = new StackLimitedCache<ReactElement>();

const showBottomBanner = (showBottomAds, isAttaches) => showBottomAds && !isAttaches;
const showAttachesBottomBanner = (hideAdsOnAttaches, isAttaches, file) => isAttaches && !hideAdsOnAttaches && Boolean(file);

export class ReactViewerComponent extends PureComponent<IProps, IState> {
    static defaultProps = {
        gaCategory: 'pdf-view',
        gaSuffix: '',
        selectItemIndexInArray: noop,
        isViewer: false,
        toggleFavorite: noop,
        onRetryItemLoad: noop,
        publishItemAction: noop,
        selectFace: noop,
        isPreviewableItem: true,
        showSnackbar: noop,
        getFitContentState: () => false,
        embedded: false,
        inFullScreen: false,
        showViewerHeader: true,
        showLogo: false,
        showBottomAds: false,
        disableZoom: false,
        isStoryViewed: false,
        hideAdsOnAttaches: false,
        showEditButton: false,
        isNewAdFormat: false,
        sharedFolderFile: false,
        sharedFolderFileBtnFeature: false,
        isEditable: false,
    };

    state: IState = {
        isLoading: false,
        thumbsCache: {},
        isInactive: false,
        forceActive: false,
        isSwiping: false,
        filePrev: null,
        zoomState: null,
        zoomStates: [],
        startShowTime: Date.now(),
        customZoomState: null,
        isFullScreen: false,
        isFitContent: false,
        hasFitContentRatio: false,
        isMousePressed: false,
        isUnpublished: false,
        showFacesFilter: false,
        showEditPdfPromo: false,
    };

    private navigateClickCount = 0;

    public contentWrapperRef: RefObject<HTMLDivElement> = createRef();
    public contentRef: HTMLDivElement | null = null;

    private timerId: number | undefined;
    private timerDocReadyId: number | undefined;

    private imgCache = {};

    private previousKeyScope = '';

    componentDidMount() {
        const {
            file,
            loadContent,
            isViewer,
            isPublic,
            getFitContentState,
            isAttaches,
            embedded,
            showPdfEditButton,
            sharedFolderFile,
            sharedFolderFileBtnFeature,
            isEditable,
        } = this.props;

        if (sharedFolderFile && isEditable) {
            xray.send(`shrd-folder-edit-btn-${sharedFolderFileBtnFeature ? 'visible' : 'hidden'}`);
        }

        if (showPdfEditButton) {
            sendXrayFunc(['pdfedit', 'show']);
        }

        if (!embedded) {
            scrollLock(this.contentWrapperRef.current);
        }

        if (!isPublic) {
            sendTmrGoal({ goal: 'show-item' });
        }
        this.sendXray('open', file ? file?.kind || 'un' : 'null');
        if (file) {
            this.sendXray('show', file.kind ?? 'un');
        }
        if (isAttaches) {
            this.sendXray('showattaches');
            userKeeper.timeEnd('cloud-viewer-ready', { score: 'app:ready' });

            if (window.performance?.timing?.connectStart) {
                const ms = Math.min(Math.round(Date.now().valueOf() - window.performance.timing.connectStart), 18000);
                if (ms >= 0) {
                    sendXrayFunc('attaches_viewer_mnt', { ms });
                    const groupVal = roundCustom(Math.round(ms), [0, 500, 1000, 2000, 3000, 4000, 5000, 7500, 10000, 20000, 30000]);
                    sendXrayFunc(`attaches_viewer_mnt_hist_${groupVal}`);
                }
            }
        }

        this.sendDwh({
            action: 'open',
            forceSend: true,
        });

        if (loadContent) {
            this.setState({ isLoading: true }, () =>
                loadContent(file, this.contentWrapperRef.current)
                    .catch(() => {})
                    .finally(() => this.setState({ isLoading: false }))
            );
        }

        if (isViewer) {
            this.previousKeyScope = hotkeys.getScope();
            hotkeys.setScope(hotKeysScope);

            hotkeys('space,right', hotKeysScope, (e) => {
                e.preventDefault();

                this.onNavigateRight();
            });

            hotkeys('f', hotKeysScope, (e) => {
                e.preventDefault();
                this.sendXray('hotkey', 'f');

                this.handleFullscreen();
            });

            hotkeys('del, delete', hotKeysScope, (e) => {
                e.preventDefault();
                this.sendXray('hotkey', 'del');

                this.handleOnDelete(this.props.file);
            });

            hotkeys('left, backspace', hotKeysScope, (e) => {
                e.preventDefault();

                this.onNavigateLeft();
            });

            hotkeys('*', hotKeysScope, (e) => {
                //  если просто ловить +, то с нампада не приходит. С нампада прилетает только в *

                // после выхода из fullscreen hotkeys прямой обработчик Escape не всегда срабатывает, потому обрабатываем тут
                if (e.key === 'Escape' && !embedded) {
                    const { zoomState, zoomStates } = this.state;
                    e.preventDefault();

                    this.sendXray('hotkey', 'esc');

                    if (zoomState && zoomState !== zoomStates[getDefaultZoomIdx()]) {
                        this.runUITimer(false);
                        this.setState({ zoomState: null });
                        return false;
                    }

                    this.handleOnClose();

                    return false;
                }

                if (['=', '+'].includes(e.key)) {
                    e.preventDefault();

                    this.sendXray('hotkey', 'zoomp');

                    this.increaseZoom(null);
                    return false;
                }

                if (e.key === '-') {
                    e.preventDefault();

                    this.sendXray('hotkey', 'zoomp');

                    this.decreaseZoom(null);
                    return false;
                }
            });
        }

        if (getFitContentState?.()) {
            this.setState({ isFitContent: true });
        }

        this.runUITimer();

        this.preloadImages();

        window.addEventListener('resize', this.handleResize);
        window.addEventListener('fullscreenchange', this.handleFullscreenChange);

        document.body.classList.add('viewer_open');

        if (file?.id) {
            this.sendDwh({
                action: 'open-content',
                forceSend: true,
            });
        }
    }

    handleResize = debounce(() => {
        const { file, embedded } = this.props;
        let { zoomState, customZoomState } = this.state;
        const { thumbsCache, isFitContent } = this.state;

        if (thumbsCache[file?.id]?.isLoaded) {
            const { width, height } = thumbsCache[file?.id];
            const { range, hasFitContentRatio } = calculateZoomValues({
                width,
                height,
                file,
                embedded,
                contentRect: this.contentRef?.getBoundingClientRect(),
            });
            if (range !== null && !range.includes(zoomState)) {
                zoomState = range[getDefaultZoomIdx(isFitContent, hasFitContentRatio)];
                customZoomState = null;
            }

            this.setState({ zoomStates: range, zoomState, customZoomState, hasFitContentRatio });
        }
    }, 250);

    componentDidUpdate(prevProps) {
        const {
            indexInArray,
            file,
            embedded,
            isPreviewableItem,
            inFullScreen,
            storyId,
            preloadUrls,
            isAttaches,
            showPdfEditButton,
            showEditButton,
        } = this.props;
        const { thumbsCache } = this.state;

        if (inFullScreen !== prevProps.inFullScreen) {
            this.handleFullscreen();
        }

        if (embedded) {
            return;
        }

        if (!storyId && ((indexInArray === null && prevProps.indexInArray !== null) || (!file && prevProps.file))) {
            this.handleOnClose();
            return;
        }

        if (preloadUrls?.length && !prevProps.preloadUrls?.length) {
            this.preloadImages();
        }

        if (storyId && storyId !== prevProps.storyId) {
            this.sendDwh({
                eventCategory: ECategoryGa.story,
                action: 'story_view',
                type_reason: prevProps.storyId ? 'switch' : 'click',
            });
        }

        if (file?.id !== prevProps.file?.id) {
            const ext = getFileExtLimit(file?.ext);

            this.sendXray('show', file?.kind ?? 'un', false, { [ext]: 1 });

            if (showPdfEditButton) {
                sendXrayFunc(['pdfedit', 'show']);
            }

            if (isAttaches) {
                this.sendXray(`show-attach-${file?.attachType}`, file?.kind ?? 'un', false, { [ext]: 1 });
            }

            if (isPreviewableItem && file?.ext === 'zip') {
                this.sendXray('show', 'archive');
            }

            this.sendDwh({ action: 'photo_in_story_view', eventCategory: ECategoryGa.story });

            this.preloadImages();

            let zoomStates = this.state.zoomStates;
            let hasFitContentRatio = this.state.hasFitContentRatio;

            if (thumbsCache[file?.id]?.isLoaded) {
                this.sendXray('showcached');

                const { width, height } = thumbsCache[file?.id];
                const { range, hasFitContentRatio: newHasRatio } = calculateZoomValues({
                    width,
                    height,
                    contentRect: this.contentRef?.getBoundingClientRect(),
                    file,
                    embedded,
                });

                zoomStates = range;
                hasFitContentRatio = newHasRatio;
                if (range?.length) {
                    this.sendXray('zoom', 'show');
                }
            }

            this.setState({ filePrev: prevProps.file, zoomStates, startShowTime: Date.now(), hasFitContentRatio });

            if (file?.kind === 'document') {
                this.setFocusForDoc();
            } else if (this.timerDocReadyId) {
                window.clearTimeout(this.timerDocReadyId);
                this.timerDocReadyId = undefined;
            }

            if (
                isPreviewableItem &&
                !(isImage(file) && getItemImageUrl(file)) &&
                !((isVideo(file) || isAudio(file)) && file?.href?.media) &&
                !file?.href?.view
            ) {
                this.sendXray('nourl', file.kind);
            }

            this.runUITimer(!isPreviewableItem);
        } else if (storyId && !prevProps.storyId) {
            this.sendDwh({ action: 'photo_in_story_view', eventCategory: ECategoryGa.story });
        }

        if (file?.id !== prevProps.file?.id && prevProps.file && (isVideo(prevProps.file) || isAudio(prevProps.file))) {
            componentsCache.updateItem(prevProps.file.id + prevProps.file.mtime, this.renderPlayer(prevProps.file, false));
        }

        if (file?.id !== prevProps.file?.id && file && (isVideo(file) || isAudio(file)) && componentsCache.getItem(file.id + file.mtime)) {
            componentsCache.updateItem(file.id + file.mtime, this.renderPlayer(file, true));
        }

        if (showEditButton && !prevProps.showEditButton) {
            this.sendXray('showeditbtn');
        }

        if (file?.id && file?.id !== prevProps.file?.id) {
            this.sendDwh({
                action: 'open-content',
                forceSend: true,
            });
        }
    }

    componentWillUnmount(): void {
        const { embedded, isViewer } = this.props;

        componentsCache.clear();

        if (!embedded) {
            scrollUnlock(this.contentWrapperRef.current);
        }

        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = undefined;
        }

        if (isViewer) {
            hotkeys.deleteScope(hotKeysScope);
            if (this.previousKeyScope) {
                hotkeys.setScope(this.previousKeyScope);
            }
        }

        window.removeEventListener('resize', this.handleResize);
        this.contentRef?.removeEventListener('wheel', this.handleWheel);
        window.removeEventListener('fullscreenchange', this.handleFullscreenChange);

        Object.keys(this.imgCache).forEach((key) => {
            this.imgCache[key].onload = null;
            this.imgCache[key].src = emptyImageUrl;
            delete this.imgCache[key];
        });

        document.body.classList.remove('viewer_open');
    }

    private onContentRefChange = (node) => {
        this.contentRef?.removeEventListener('wheel', this.handleWheel);

        this.contentRef = node;

        this.contentRef?.addEventListener('wheel', this.handleWheel, { passive: false });
    };

    private onNavigateLeft = () => {
        const { backItemIndexInArray } = this.props;

        if (backItemIndexInArray !== null) {
            this.sendXray('hotkey', 'navigate');
            this.handleNavigation({ itemIndex: backItemIndexInArray });
        }
    };

    private onNavigateRight = () => {
        const { forwardItemIndexInArray } = this.props;

        if (forwardItemIndexInArray !== null) {
            this.sendXray('hotkey', 'navigate');
            this.handleNavigation({ itemIndex: forwardItemIndexInArray });
        }
    };

    private setFocusForDoc = () => {
        if (this.timerDocReadyId) {
            window.clearTimeout(this.timerDocReadyId);
        }
        this.contentRef?.focus();
        this.timerDocReadyId = window.setTimeout(() => {
            this.contentRef?.focus();
            this.timerDocReadyId = undefined;
        }, 1000);
    };

    private sendDwh = ({
        action,
        type_click,
        eventCategory,
        type_reason,
        storyId = this.props.storyId,
        forceSend = false,
        percent_close,
    }: IViewerDwhData) => {
        const { itemStorage, itemCount, storyType, file, faces, isPreviewableItem } = this.props;

        const source = IS_PUBLIC_ALBUM ? 'album' : itemStorage || '';

        if (forceSend || (storyType && storyId && file)) {
            sendViewerDwh({
                eventCategory,
                count_media: itemCount ?? 0,
                id_media: file?.id ? sha1(file?.id) : '',
                id_story: storyId || '',
                id_public: itemStorage === EStorageType.public ? getWeblinkFromPublicId(file?.id) : 'None',
                source,
                type_content: file?.kind,
                extension: file?.ext?.toLowerCase() || '',
                type_story: storyType,
                action,
                is_stories: itemStorage === EStorageType.story,
                type_click,
                type_reason,
                have_face: faces && faces.length > 0,
                is_full_render: isPreviewableItem,
                is_edit: false,
                size_files: file?.size,
                percent_close,
            });
        }
    };

    private sendXray = (action, label = '', sendImmediately = false, data: null | Record<string, number> = null) => {
        const { gaCategory, gaSuffix, itemStorage } = this.props;

        let dataSend: Record<string, number> | null = null;
        if (gaSuffix) {
            dataSend = { [gaSuffix]: 1 };
        }
        if (data) {
            dataSend = dataSend ? { ...dataSend, ...data } : data;
        }

        sendXrayFunc([gaCategory, action, label], dataSend, { sendImmediately });
        if (itemStorage) {
            sendXrayFunc([`${gaCategory}-${itemStorage}`, action, label], dataSend, { sendImmediately });
        }
    };

    private increaseZoom = (event) => {
        const { zoomState, zoomStates, customZoomState, isFitContent, hasFitContentRatio } = this.state;
        const { setFitContentState = noop, disableZoom } = this.props;

        if (disableZoom) {
            return;
        }

        event?.stopPropagation();
        this.runUITimer();

        const currentZoom = (customZoomState || zoomState) as number;

        if (currentZoom === null && zoomStates.length > 1) {
            this.sendXray('zoom', 'inc');

            this.setState({
                zoomState: zoomStates[getDefaultZoomIdx(false, hasFitContentRatio) + 1],
                customZoomState: null,
                isFitContent: false,
            });
            if (isFitContent) {
                setFitContentState(false);
            }
            return;
        }

        let idx = zoomStates.indexOf(currentZoom);
        if (idx === -1) {
            idx = tryGetNearestIndexOfValue(zoomStates, currentZoom);
        }
        if (idx !== -1 && idx < zoomStates.length - 1) {
            this.sendXray('zoom', 'inc');

            this.setState({ zoomState: zoomStates[idx + 1], customZoomState: null, isFitContent: false });
            if (isFitContent) {
                setFitContentState(false);
            }
        }
    };

    private decreaseZoom = (event) => {
        const { zoomState, zoomStates, customZoomState, hasFitContentRatio } = this.state;
        const { setFitContentState = noop, disableZoom } = this.props;

        if (disableZoom) {
            return;
        }

        event?.stopPropagation();
        this.runUITimer();

        const currentZoom = (customZoomState || zoomState) as number;

        let idx = zoomStates.indexOf(currentZoom);
        if (idx === -1) {
            idx = tryGetNearestIndexOfValue(zoomStates, currentZoom) + 1;
        }
        let newIdx;
        if (idx > 0) {
            this.sendXray('zoom', 'dec');

            newIdx = idx - 1;
        } else if (idx === 0) {
            newIdx = 0;
        }

        if (newIdx < 0) {
            return;
        }

        this.setState({ zoomState: zoomStates[newIdx], customZoomState: null });

        if (newIdx !== 0) {
            return;
        }

        if (hasFitContentRatio) {
            setFitContentState(true);
            this.setState({ isFitContent: true });
        }
        if (idx === 0) {
            this.sendXray('zoom', 'declastpress');
        }
    };

    private resetZoom = () => {
        this.setState({ zoomState: null, zoomStates: [], customZoomState: null });
    };

    private handleWheel = (event) => {
        const { customZoomState, zoomStates, zoomState, isFitContent, hasFitContentRatio } = this.state;
        const { file, isPreviewableItem, disableZoom } = this.props;

        if (!zoomStates?.length || event?.type !== 'wheel' || (isPreviewableItem && file?.ext === 'zip') || disableZoom) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const defaultZoomValue = zoomStates[getDefaultZoomIdx(isFitContent, hasFitContentRatio)] as number;
        const zoomValue = (customZoomState || zoomState || defaultZoomValue) as number;

        const newCustomZoomState = Math.min(Math.max(zoomValue - Math.sign(event.deltaY) * 1, zoomStates[0] as number), MAX_ZOOM_STATE);

        this.setState({ customZoomState: newCustomZoomState });

        const newFitState = newCustomZoomState === zoomStates[0] && hasFitContentRatio;

        if (isFitContent !== newFitState) {
            this.props.setFitContentState?.(newFitState);
            this.setState({ isFitContent: newFitState });
        }

        this.runUITimer();
    };

    // TODO: make preload in saga? make special viewer action for it? How to use common cache?
    private preloadImages = () => {
        const { enablePreload, preloadUrls } = this.props;

        if (enablePreload && preloadUrls?.length) {
            const { thumbsCache } = this.state;

            const prevKeys = Object.keys(this.imgCache);
            prevKeys.forEach((key) => {
                if (!preloadUrls.find((item) => item?.url === key)) {
                    this.imgCache[key].onload = null;
                    this.imgCache[key].src = emptyImageUrl;
                    delete this.imgCache[key];
                }
            });

            preloadUrls.forEach(({ url, id }) => {
                if (!thumbsCache[id]?.isLoaded && url) {
                    if (!this.imgCache[url]) {
                        this.imgCache[url] = new Image();
                    }
                    this.imgCache[url].onload = (event) => this.handleImageLoad({ id, event, preload: true });
                    this.imgCache[url].src = url;
                }
            });
        }
    };

    private handleUITimer = () => {
        const { thumbsCache } = this.state;
        const item = this.props.file;

        this.timerId = undefined;

        if (!isImage(item) || thumbsCache[item?.id]?.isLoaded) {
            this.setState({ isInactive: true });
        } else {
            this.timerId = window.setTimeout(this.handleUITimer, TIMEOUT_TO_INACTIVE);
        }
    };

    private runUITimer = (makeActive = true) => {
        const { isPreviewableItem, file, itemStorage } = this.props;

        if (itemStorage === EStorageType.story) {
            return;
        }

        if (this.state.isInactive && makeActive) {
            this.setState({ isInactive: false });
        }

        if (this.timerId) {
            window.clearTimeout(this.timerId);
        }

        if ((!isVideo(file) && !isImage(file)) || !isPreviewableItem || this.state.forceActive) {
            return;
        }

        this.timerId = window.setTimeout(this.handleUITimer, TIMEOUT_TO_INACTIVE);
    };

    private showUIAndSetupTimer = throttle(() => {
        this.runUITimer();
    }, 250);

    private handleEdit = () => {
        const { file } = this.props;

        this.sendXray('openeditor');

        openEditor(file);
    };

    private handleEditPdf = () => {
        sendXrayFunc(['pdfedit', 'click']);

        this.props.markEditPdfButtonAsViewed?.();
        this.setState({ showEditPdfPromo: true });
    };

    private handleCloseEditPdfPromo = () => this.setState({ showEditPdfPromo: false });

    private handleOnClose = () => {
        const {
            onClose = noop,
            ids,
            storyId,
            indexInArray,
            itemCount = 0,
            markStoryAsViewed,
            file,
            isStoryViewed = false,
            isAttaches,
        } = this.props;
        const { isFullScreen } = this.state;

        if (!isStoryViewed) {
            const isLastItem = indexInArray === itemCount - 1;
            markStoryAsViewed?.({ storyId: storyId as string, lastViewedId: isLastItem ? '' : file?.id });
        }

        this.sendXray('close');

        if (ids?.length) {
            const navProc = Math.round((this.navigateClickCount * 100) / ids?.length);
            const group = roundCustom(ids?.length, [0, 5, 10, 25, 50]);

            this.sendXray('stat', `nav${group}`, true, { proc: navProc });
        }

        if (isFullScreen) {
            this.handleFullscreen();
        }

        if (isAttaches && BACK_URL) {
            open(decodeURIComponent(BACK_URL), '_self');
        }

        this.sendDwh({
            eventCategory: ECategoryGa.story,
            action: 'story_close',
            type_reason: 'click',
        });

        onClose();
    };

    private handleFullscreen = () => {
        const { isFullScreen } = this.state;

        if (isFullScreen) {
            document.exitFullscreen()?.catch(() => this.sendXray('fs-stop-err'));
        } else {
            document.documentElement.requestFullscreen?.()?.catch(() => this.sendXray('fs-start-err'));
        }
    };

    private handleFullscreenChange = (event) => {
        // eslint-disable-next-line compat/compat
        const isFullScreen = document.fullscreenElement === event.target;
        this.setState({ isFullScreen });
        this.sendXray('fs', isFullScreen ? 'start' : 'stop');
    };

    private handleDownload = (item = undefined) => {
        const { isAttaches, activeArchiveItem, itemStorage, downloadArchiveItemAction, file } = this.props;

        this.sendXray('click', 'download');
        this.sendDwh({ action: 'download_content', forceSend: true });
        if (isAttaches) {
            this.sendXray('attach', 'dwnldclk');
        }

        if (file.ext === 'zip' && !isAttaches) {
            this.sendXray('archive', 'dwnldzip');
        }

        if (activeArchiveItem && itemStorage && downloadArchiveItemAction) {
            downloadArchiveItemAction({
                storage: itemStorage,
                archiveId: itemStorage === EStorageType.public ? file?.weblink : file?.id,
                itemId: activeArchiveItem.path,
            });
        } else {
            downloadItem({ itemOrId: item ?? file, fromViewer: true });
        }

        this.runUITimer();
    };

    private handleClickOnStub = () => {
        this.handleDownload();
    };

    private handleToggleFavorite = (item) => {
        const { toggleFavorite = noop, itemStorage, showSnackbar } = this.props;

        this.sendXray('click', 'favorite');
        this.sendDwh({ action: 'favorites', forceSend: true });

        if (itemStorage === EStorageType.story && !item.isInFavorites) {
            showSnackbar({
                id: 'add-to-favorites',
                closable: true,
                text: 'Файл добавлен в избранные',
                type: SnackbarTypes.success,
            });
        }

        toggleFavorite(item);

        this.runUITimer();
    };

    private handleOnPublish = ({ item, event }): void => {
        const { itemStorage, isPublic, isStock, showSnackbar, publishItemAction } = this.props;
        event.stopPropagation();

        this.sendXray('click', 'publish');
        this.sendDwh({ action: 'new_public', forceSend: true });

        // eslint-disable-next-line unicorn/consistent-function-scoping
        const handleUnpublishSuccess = () => {
            this.setState({ isUnpublished: true });
        };

        processItemPublish({ itemStorage, isPublic, isStock, showSnackbar, publishItemAction, item, handleUnpublishSuccess });
    };

    private handleOnDelete = (item) => {
        const { deleteFile = noop, itemStorage } = this.props;

        this.sendXray('click', 'delete');
        const onSuccess = () => this.sendDwh({ action: 'delete', forceSend: true });

        // eslint-disable-next-line max-lines
        deleteFile(item, itemStorage, onSuccess);
    };

    private handleNavigation = throttle((data, isSwiping = false) => {
        const { indexInArray, selectItemIndexInArray } = this.props;

        // eslint-disable-next-line max-lines
        this.resetZoom();

        this.setState({ isSwiping });

        selectItemIndexInArray(data);

        this.sendXray('click', 'navigate');
        if (indexInArray !== null) {
            const type_click = data?.itemIndex > (indexInArray ?? 0) ? 'next' : 'previous';
            this.sendDwh({ action: 'skip_photo', type_click, forceSend: true });
        }

        this.navigateClickCount++;
    }, 100);

    private handleImageError = (srcUrl, id) => {
        this.sendXray('imgload', 'error');

        this.setState(({ thumbsCache }) => ({
            thumbsCache: { ...thumbsCache, [id]: { isError: true } },
        }));
    };

    private handleImageLoad = ({ id, event, preload = false }) => {
        const { file, embedded } = this.props;
        this.sendXray('imgload', 'ok', false, preload ? { preload: 1 } : null);

        const diffTime = Date.now() - this.state.startShowTime;
        this.sendXray('imgloag', 'time', false, { ms: diffTime });
        if (!preload) {
            this.sendXray('imgloag', 'timemain', false, { ms: diffTime });
        }
        this.sendXray('imgloag', `histogram_${roundCustom(diffTime, [0, 10, 100, 250, 500, 750, 1000, 2000, 3000, 4000, 5000, 10000])}`);

        const height = event.target?.naturalHeight;
        const width = event.target?.naturalWidth;

        if (!this.state.thumbsCache[id]?.isLoaded) {
            let { zoomStates: zoomStatesNew, hasFitContentRatio: hasFitContentRatioNew } = this.state;
            if (id === file?.id) {
                const { range, hasFitContentRatio } = calculateZoomValues({
                    width,
                    height,
                    file,
                    embedded,
                    contentRect: this.contentRef?.getBoundingClientRect(),
                });

                zoomStatesNew = range;
                hasFitContentRatioNew = hasFitContentRatio;

                if (zoomStatesNew?.length) {
                    this.sendXray('zoom', 'show');
                }
            }

            this.setState(({ thumbsCache, zoomStates }) => ({
                zoomStates: zoomStatesNew ?? zoomStates,
                hasFitContentRatio: hasFitContentRatioNew,
                thumbsCache: {
                    ...thumbsCache,
                    [id]: {
                        isLoaded: true,
                        height,
                        width,
                    },
                },
            }));
        }
    };

    private handleReloadImage = (srcUrl, id) => {
        const { onRetryItemLoad = noop, indexInArray } = this.props;

        this.sendXray('imgload', 'retry');

        this.setState(({ thumbsCache }) => ({
            thumbsCache: { ...thumbsCache, [id]: { isRetry: true } },
        }));

        onRetryItemLoad({ src: srcUrl, idx: indexInArray });
    };

    private handleActiveHeader = ({ isActive }) => {
        this.setState({ forceActive: isActive }, this.runUITimer);
    };

    private handleCopy = () => {
        this.sendXray('click', 'copy');

        renderCopyDialog({
            items: [this.props.file],
            onSuccess: () => this.sendDwh({ action: 'copy', forceSend: true }),
        });
    };

    private handleMove = () => {
        this.sendXray('click', 'move');

        renderMoveDialog({
            items: [this.props.file],
            onSuccess: () => this.sendDwh({ action: 'move_to_folder', forceSend: true }),
        });
    };

    private handleMail = () => {
        this.sendXray('click', 'move');
        this.sendDwh({ action: 'send_mail', forceSend: true });

        toolbarActions.forward({ items: [this.props.file] });
    };

    private handleClone = () => {
        const { isAttaches } = this.props;

        if (isAttaches) {
            this.sendXray('attach', 'clonedclk');
        }
        this.sendXray('click', 'clone');

        toolbarActions.clone({
            id: this.props.file.id,
            destination: isAttaches ? MAIL_ATTACHES_FOLDER_ID : '',
            source: isAttaches ? 'viewer-attaches' : 'viewer',
        });
    };

    private handleOpenParent = () => {
        const parent = this.props.file.parentFolder || this.props.file.parent || '';
        const folder = encodeURIComponent(parent === '/' ? '' : parent);
        const file = encodeURIComponent(this.props.file.id);

        this.sendXray('click', 'open-parent');
        this.sendDwh({ action: 'view_in_folder', forceSend: true });

        opener(`${window.location.origin}/home${folder}/?item=${file}&action=scroll-to`);
    };

    private handleOpenInMyCloud = () => {
        const { file } = this.props;

        this.sendXray('click', 'open-in-cloud');

        if (!file || !('home' in file)) {
            return;
        }

        const url = getGoToAndScrollUrl(file.home?.replace(file.name, '') ?? '', file.home);
        opener(url);
    };

    private handleDocReady = () => {
        this.setFocusForDoc();
    };

    private handleOpenAttachMessage = () => {
        const { folder_id = '', message_id = '', attachType } = this.props.file || {};

        if (attachType === EAttachTypes.temporary) {
            return;
        }

        this.sendXray('attachinfo', 'click', true);

        opener(`//${MAIL_HOST}/message/${message_id}/${folder_id ? `?folder_id=${folder_id}` : ''}`);
    };

    private handleOnDetailsClick = () => {};

    private handleShowFaceFilter = () => this.setState({ showFacesFilter: !this.state.showFacesFilter });

    private handleOnFaceSelect = (id) => {
        this.sendDwh({
            action: 'select_face',
            forceSend: true,
        });

        this.props.selectFace?.(id);
        this.handleOnClose();
    };

    private handleVideoError = (msg?: string) => {
        const { showSnackbar } = this.props;
        showSnackbar({
            id: 'video-player-error',
            type: SnackbarTypes.failure,
            text: msg || 'Ошибка воспроизведения. Неизвестный кодек видео.',
            closable: true,
        });
    };

    private renderImage = ({ zoomValue, defaultZoomValue, file }) => {
        const { faces } = this.props;
        const { thumbsCache, filePrev, zoomStates, customZoomState, isSwiping, hasFitContentRatio, showFacesFilter } = this.state;

        zoomValue = (customZoomState || zoomValue || defaultZoomValue) as number;

        let scale = 1;

        if (zoomValue) {
            scale = zoomValue / (zoomStates[getDefaultZoomIdx(false, hasFitContentRatio)] as number);
        }

        const id = file?.id;

        const src = getItemImageUrl(file);
        let srcPrev = '';
        if (filePrev && !thumbsCache[filePrev.id]?.isError && thumbsCache[filePrev.id]?.isLoaded) {
            srcPrev = getItemImageUrl(filePrev);
        }

        const { isError, isLoaded, isRetry } = thumbsCache[id] || {};

        const contentRect = this.props.embedded ? this.contentRef?.getBoundingClientRect() : null;

        return (
            <>
                <ViewerImage
                    src={src}
                    srcPrev={srcPrev}
                    isError={isError}
                    isLoaded={isLoaded}
                    isRetry={isRetry}
                    file={file}
                    filePrev={filePrev}
                    scale={scale}
                    onImageLoad={this.handleImageLoad}
                    onImageError={this.handleImageError}
                    onReloadImage={this.handleReloadImage}
                    enableAnimationPrev={!isSwiping}
                    embedded={this.props.embedded}
                    contentRect={contentRect}
                    faces={faces}
                    clickOnFace={this.handleOnFaceSelect}
                    showFacesFilter={showFacesFilter}
                />
            </>
        );
    };

    private renderPlayer = (file, isVisible = true) => {
        const { isActionOpen, isAttaches } = this.props;
        return (
            <VideoPlayer
                streamUri={file?.url?.media}
                nativeUrl={file?.url?.view}
                posterUrl={getPosterUrl(file)}
                kind={file.kind}
                ext={file.ext}
                name={file.nameWithoutExt || file.name}
                autoPlay={isActionOpen}
                isVisible={isVisible}
                size={file?.size}
                isAttaches={isAttaches}
                onError={this.handleVideoError}
            />
        );
    };

    private renderPdf = (file) => {
        if (!file?.url?.view) {
            return null;
        }

        return <ViewerPdf url={file?.url?.view} renderError={() => this.renderStub(file)} fillParent={this.props.itemCount === 1} />;
    };

    private renderTxt = (file) => {
        if (!file?.url?.view) {
            return null;
        }

        return <ViewerTxt url={file?.url?.view} renderError={() => this.renderStub(file)} embedded={this.props.embedded} />;
    };

    private renderDoc = (file) => {
        return (
            <ViewerDoc file={file} renderError={() => this.renderStub(file)} onReady={this.handleDocReady} embedded={this.props.embedded} />
        );
    };

    private renderStub = (file) => (
        <Stub
            ext={file?.ext}
            kind={file?.kind}
            isVirus={isVirusItem(file)}
            name={file?.nameWithoutExt ?? file?.name}
            onClick={this.handleClickOnStub}
        />
    );

    private renderArchive = (file, storage) => (
        <div className={styles.archiveWrapper}>
            <ViewerArchiveConnected
                file={file}
                storage={storage}
                sendGa={this.sendXray}
                embedded={this.props.embedded}
                onClose={this.handleOnClose}
                onDelete={this.handleOnDelete}
                onNavigate={(isLeft) => (isLeft ? this.onNavigateLeft() : this.onNavigateRight())}
            />
        </div>
    );

    private renderContentItem = ({ zoomValue, defaultZoomValue }) => {
        // eslint-disable-next-line max-lines
        const { file, isPreviewableItem, itemStorage } = this.props;

        const id = file?.id;
        const cacheKey = id + file?.mtime;
        let cashedItem: ReactElement | undefined | null = componentsCache.getItem(cacheKey);
        let content: ReactElement | ReactElement[] | null = null;

        if (isPreviewableItem && !cashedItem) {
            if (isImage(file)) {
                content = this.renderImage({ zoomValue, defaultZoomValue, file });
            } else if (isVideo(file) || isAudio(file)) {
                cashedItem = this.renderPlayer(file, true);
            } else if (isPdf(file)) {
                cashedItem = this.renderPdf(file);
            } else if (isPlainSource(file, itemStorage)) {
                cashedItem = this.renderTxt(file);
            } else if (isDocument(file)) {
                cashedItem = this.renderDoc(file);
            } else if (file?.kind === 'archive' || file?.subKind === 'archive') {
                content = this.renderArchive(file, itemStorage);
            }

            if (cashedItem) {
                componentsCache.addItem(cacheKey, cashedItem);
            }
        }

        if (!content && !cashedItem) {
            content = this.renderStub(file);
        }

        return (
            <>
                {content}
                {/* Рендерим все закешированные компоненты скрытыми. Если не отрендерить - они отмонтируются и соотв. DOM компоненты удалятся. */}
                {componentsCache.getAll().map(
                    ({ key, item }): ReactElement => (
                        <div
                            key={key}
                            className={classNames({
                                [styles.cachedItem]: true,
                                [styles.cachedItem_hidden]: key !== cacheKey,
                            })}
                        >
                            {item}
                        </div>
                    )
                )}
            </>
        );
    };

    private handleOnDown = () => {
        this.setState({ isMousePressed: true });
    };

    private handleOnUp = () => {
        this.setState({ isMousePressed: false });
    };

    private renderContentSlider = (): ReactElement | null => {
        const {
            loadContent,
            file,
            forwardItemIndexInArray,
            backItemIndexInArray,
            itemCount,
            isAttaches,
            disableZoom,
            showBottomAds,
            showEditButton,
            showPdfEditButton,
        } = this.props;
        const { isLoading, isInactive, zoomState, zoomStates, customZoomState, isFitContent, hasFitContentRatio, showEditPdfPromo } =
            this.state;

        if (isLoading || !!loadContent || !file) {
            return null;
        }

        const zoomValue = customZoomState || zoomState;
        const defaultZoomValue = zoomStates[getDefaultZoomIdx(isFitContent, hasFitContentRatio)];

        const disableSwipe = Boolean((zoomValue && zoomValue !== defaultZoomValue) || itemCount === 1);

        return (
            <div className={styles.contentBlock}>
                <SwipingComponent
                    id={file?.id}
                    onSwipe={(toRight = false) => {
                        const itemIndex = toRight ? backItemIndexInArray : forwardItemIndexInArray;
                        this.runUITimer();
                        if (itemIndex !== null) {
                            this.handleNavigation({ itemIndex }, true);
                        }
                    }}
                    disable={disableSwipe}
                    enableForward={forwardItemIndexInArray !== null}
                    enableBack={backItemIndexInArray !== null}
                >
                    <div
                        ref={this.onContentRefChange}
                        className={styles.content}
                        tabIndex={0}
                        onMouseDown={this.handleOnDown}
                        onMouseUp={this.handleOnUp}
                    >
                        {this.renderContentItem({ zoomValue, defaultZoomValue })}
                    </div>
                </SwipingComponent>
                {showEditButton && (
                    <div className={styles.controls}>
                        <ViewerButton
                            title={isAttaches ? 'Сохранить и редактировать' : 'Редактировать документ'}
                            onClick={this.handleEdit}
                            icon={<EditIcon />}
                            qaName="edit"
                        />
                    </div>
                )}
                {showPdfEditButton && (
                    <div className={styles.controls}>
                        <ViewerButton title="Редактировать PDF" onClick={this.handleEditPdf} icon={<EditIcon />} qaName="edit-pdf" />
                    </div>
                )}
                {showEditPdfPromo && (
                    <BaseConfirmDialog
                        dataQAId="edit-pdf-promo"
                        renderHeader={() => 'В разработке'}
                        cancelButtonText="Отмена"
                        buttons={[EButtonType.ok]}
                        onClose={this.handleCloseEditPdfPromo}
                        onSuccess={this.handleCloseEditPdfPromo}
                        renderContent={() => 'Спасибо за ваш интерес. Мы уведомим вас после запуска редактирования PDF.'}
                        loading={false}
                    />
                )}
                {!disableZoom &&
                    this.renderZoomer(
                        zoomValue ?? defaultZoomValue,
                        !isInactive,
                        isAttaches || showBottomBanner(showBottomAds, isAttaches)
                    )}
                {this.renderNavigator(isInactive)}
            </div>
        );
    };

    private renderZoomer = (zoomValue, show, upOnBannerHeight = false) => {
        if (!zoomValue) {
            return null;
        }

        return (
            <div>
                <div
                    className={classNames({
                        [styles.zoomer]: true,
                        [styles.zoomer_show]: show,
                        [styles.zoomer_upOnBannerHeight]: upOnBannerHeight,
                    })}
                >
                    <Hint text="Уменьшить" theme="dark" showDelay>
                        <div className={styles.zoomButton} onMouseDown={this.decreaseZoom}>
                            -
                        </div>
                    </Hint>
                    <div className={styles.zoomValue}>{zoomValue}%</div>
                    <Hint text="Увеличить" theme="dark" showDelay>
                        <div className={styles.zoomButton} onMouseDown={this.increaseZoom}>
                            +
                        </div>
                    </Hint>
                </div>
            </div>
        );
    };

    private renderNavigator = (isInactive) => {
        const { backItemIndexInArray, forwardItemIndexInArray, itemCount, itemStorage } = this.props;

        if ((!itemCount || itemCount === 1) && itemStorage !== EStorageType.story) {
            return null;
        }

        const navBackHandler =
            backItemIndexInArray !== null
                ? () => {
                      this.handleNavigation({ itemIndex: backItemIndexInArray });
                      this.runUITimer();
                  }
                : noop;
        const navForwardHandler =
            forwardItemIndexInArray !== null
                ? () => {
                      this.handleNavigation({ itemIndex: forwardItemIndexInArray });
                      this.runUITimer();
                  }
                : noop;

        return (
            <div className={classNames({ [styles.navigator]: true, [styles.dimout]: isInactive })}>
                <Hint text="Предыдущий файл" theme="dark" showDelay>
                    <div
                        className={classNames({
                            [styles.arrow]: true,
                            [styles.arrow_enabled]: backItemIndexInArray != null,
                            [styles.arrow_hidden]: backItemIndexInArray === null && itemStorage === EStorageType.story,
                        })}
                        onMouseDown={navBackHandler}
                    >
                        <LeftArrowIcon width={17} height={16} />
                    </div>
                </Hint>
                <Hint text="Следующий файл" theme="dark" showDelay>
                    <div
                        className={classNames({
                            [styles.arrow]: true,
                            [styles.arrow_right]: true,
                            [styles.arrow_enabled]: forwardItemIndexInArray != null,
                            [styles.arrow_hidden]: forwardItemIndexInArray === null && itemStorage === EStorageType.story,
                        })}
                        onMouseDown={navForwardHandler}
                    >
                        <RightArrowIcon width={17} height={16} />
                    </div>
                </Hint>
            </div>
        );
    };

    // eslint-disable-next-line max-lines-per-function
    public render(): ReactElement | null {
        const {
            isPublic,
            isStock,
            isMountedFolder,
            showEditorHeader,
            gaCategory,
            isViewer,
            itemStorage,
            file,
            isAuthorized,
            activeArchiveItem,
            isAttaches = false,
            embedded,
            showViewerHeader,
            showBottomAds,
            showLogo,
            isAttachesEnabled,
            topTitle,
            topSubTitle,
            storyType,
            bottomTitle,
            bottomSubTitle,
            itemCount,
            indexInArray,
            forwardItemIndexInArray,
            isDialogShown,
            hideAdsOnAttaches,
            faces,
            isNewAdFormat,
        } = this.props;
        const { isLoading, isInactive, isFullScreen, isMousePressed, isUnpublished, showFacesFilter } = this.state;

        const showBottomAd = showBottomBanner(showBottomAds, isAttaches) || showAttachesBottomBanner(hideAdsOnAttaches, isAttaches, file);

        return (
            <div className={classNames({ [styles.wrapper]: true, [styles.wrapper_embedded]: embedded })}>
                <div className={classNames({ [styles.facesWrapper]: true, [styles.facesWrapper_hidden]: !showFacesFilter })}>
                    <FaceFilter faces={faces} onHideClick={this.handleShowFaceFilter} onFaceSelect={this.handleOnFaceSelect} />
                </div>
                <div
                    className={classNames({
                        [styles.root]: true,
                        [styles.root_embedded]: embedded,
                        [styles.root_withHeader]: showViewerHeader,
                        [styles.root_withBottom]: showBottomAd,
                        [styles.root_withBottom_new]: showBottomAd && isNewAdFormat,
                        [styles.root_attaches]: itemStorage === EStorageType.attaches || itemStorage === EStorageType.viewerAttaches,
                        [styles.root_noPadding]: this.props.itemCount === 1 || embedded,
                    })}
                    onMouseMove={this.showUIAndSetupTimer}
                    onClick={this.showUIAndSetupTimer}
                    id={REACT_VIEWER_ID}
                >
                    {!!showEditorHeader && !isViewer && (
                        /* EditorHeader приконнекчен и пока сам берет себе айтем из стора - надо убрать это */
                        <EditorHeader
                            isPublic={isPublic}
                            gaCategoryMod={gaCategory}
                            enableFavorites={!isPublic && !isMountedFolder}
                            onBackToCloud={this.handleOnClose}
                            returnButtonTitle={isViewer ? 'Закрыть' : 'Вернуться в Облако'}
                            isViewer={isViewer}
                            itemStorage={itemStorage}
                        />
                    )}
                    {!!isViewer && showViewerHeader && (
                        <div className={classNames({ [styles.headerWrapper]: true, [styles.dimout]: isInactive && !embedded })}>
                            <ViewerHeader
                                isStock={isStock}
                                isPublic={isPublic}
                                isAttaches={isAttaches}
                                isAuthorized={isAuthorized}
                                embedded={embedded}
                                enableFavorites={!isPublic && !isMountedFolder && !file?.isMounted}
                                onClose={this.handleOnClose}
                                onDownload={this.handleDownload}
                                onToggleFavorites={this.handleToggleFavorite}
                                onPublish={this.handleOnPublish}
                                onDelete={this.handleOnDelete}
                                onCopy={this.handleCopy}
                                onMove={this.handleMove}
                                onMail={this.handleMail}
                                onClone={this.handleClone}
                                onOpenParent={this.handleOpenParent}
                                onActive={this.handleActiveHeader}
                                onFullscreen={this.handleFullscreen}
                                onOpenInMyCloud={this.handleOpenInMyCloud}
                                isFullScreen={isFullScreen}
                                item={activeArchiveItem ?? file}
                                onFileClick={this.handleOpenAttachMessage}
                                isArchiveItem={Boolean(activeArchiveItem)}
                                showLogo={showLogo}
                                isB2BBizUser={IS_B2B_BIZ_USER}
                                isAttachesEnabled={isAttachesEnabled}
                                renderTopChildren={(isActive) =>
                                    itemStorage === EStorageType.story && (
                                        <div className={styles.storyNavigator}>
                                            <PaginatorLine
                                                onClick={this.handleNavigation}
                                                count={itemCount ?? 0}
                                                currentIdx={indexInArray ?? 0}
                                                autoTransition={!isActive && !isDialogShown && !isMousePressed}
                                                nextBlockId={forwardItemIndexInArray}
                                                id={file?.id}
                                            />
                                        </div>
                                    )
                                }
                                topTitle={topTitle}
                                topSubTitle={topSubTitle}
                                isUnpublished={isUnpublished}
                                facesCount={faces?.length}
                                onShowFaceFilter={this.handleShowFaceFilter}
                                showFacesFilter={showFacesFilter}
                                itemStorage={itemStorage}
                            />
                        </div>
                    )}
                    {(isLoading || !file) && <Spinner />}
                    <div className={classNames({ [styles.contentWrapper]: true, [styles.viewer]: isViewer })} ref={this.contentWrapperRef}>
                        {this.renderContentSlider()}
                        {showBottomBanner(showBottomAds, isAttaches) && <BottomBanner isPublic={embedded} />}
                        {showAttachesBottomBanner(hideAdsOnAttaches, isAttaches, file) && (
                            <AttachesBanner adsUpdateTimerMs={ADS_TIMER_MS} />
                        )}
                        <BottomToolbar
                            type={storyType}
                            title={bottomTitle}
                            subTitle={bottomSubTitle}
                            onDetailsClick={this.handleOnDetailsClick}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
